import { compose } from 'ramda'
import { connect } from 'react-redux'
import { withHandlers } from 'recompose'
import { graphql } from 'react-apollo'

import { withTheme } from 'modules/util'
import { Builder, Strongest } from '../../../selectors'

import { serializeGameResult } from './utils'
import createGameResult from './createGameResult.graphql'
import previewTheme from './theme.scss'

// eslint-disable-next-line no-empty-function
const handleGameResult = () => {}

const handlers = {
  handleGameResult
}

function mapStateToProps(state, { id }) {
  const selected = Strongest.selected(state)

  return {
    completed: selected !== null,
    part: Builder.part(selected || 0, state),
    gameResult: serializeGameResult(state, id)
  }
}

export default compose(
  connect(mapStateToProps),
  graphql(createGameResult),
  withHandlers(handlers),
  withTheme(previewTheme)
)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Strongest/Preview/enhancers.js